import { render, staticRenderFns } from "./OldDashboard.vue?vue&type=template&id=d8710f66"
import script from "./OldDashboard.vue?vue&type=script&lang=js"
export * from "./OldDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports